import React from 'react';
import PropTypes from 'prop-types';
import { Input, Label, FormGroup } from 'reactstrap';
import { HasErrors } from './Errors';
import { Validate } from '../../app/config';

function CheckBox(props) {
  const {
    children,
    validation = {},
    disabled,
    label,
    subLabel,
    description,
    suffix,
    required,
    showErrors = true,
    labelClassName = '',
    groupClassName = '',
    inputClassName = '',
    id,
    field,
    checked,
    ...rest
  } = props;

  const { value = false, state = {} } = validation;
  var fieldName =
    typeof field === 'string' ? field : `${field[0]}[${field[1]}]`;
  const isRequired =
    required || (validation && validation.rules && validation.rules.required);

  let dynamicProps = {};
  if (suffix) {
    dynamicProps['aria-labelledby'] = `${id}-desc`;
  }

  return (
    <FormGroup
      className={`${groupClassName} ${disabled ? 'disabled-input' : ''} ${
        isRequired ? 'required-input' : ''
      }`.trim()}
    >
      <Input
        aria-describedby={
          HasErrors(validation)
            ? null
            : `error-${fieldName.replace('[', '-').replace(']', '')}-validation`
        }
        value={value}
        invalid={Validate.isInvalid(state)}
        valid={Validate.isValid(state)}
        checked={checked}
        disabled={disabled}
        required={required}
        id={id}
        name={fieldName}
        className={inputClassName}
        type="checkbox"
        {...dynamicProps}
        {...rest}
      />
      {label || subLabel || description ? (
        <Label check className={labelClassName} id={`${id}-label`} htmlFor={id}>
          {label}
          {isRequired ? (
            <React.Fragment>
              <span aria-hidden="true"></span>
            </React.Fragment>
          ) : (
            ''
          )}{' '}
          {subLabel && subLabel.length > 0 ? <small>{subLabel}</small> : ''}
          {description && description.length > 0 ? (
            <span className="description">{description}</span>
          ) : (
            ''
          )}
        </Label>
      ) : (
        ''
      )}
      {showErrors ? <React.Fragment></React.Fragment> : ''}
      {suffix && (
        <p className="suffix" id={`${id}-desc`}>
          {suffix}
        </p>
      )}
      {children}
    </FormGroup>
  );
}

CheckBox.propTypes = {
  /**
   * Any children of the component
   */
  children: PropTypes.element,
  /**
   * Text description text
   */
  description: PropTypes.string,
  /**
   * Text descriptionExample text
   */
  descriptionExample: PropTypes.string,
  /**
   * Text input disabled or not
   */
  disabled: PropTypes.bool,
  /**
   * Input field names
   */
  field: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  /**
   * Style class name for group
   */
  groupClassName: PropTypes.string,
  /**
   * Date ID
   */
  id: PropTypes.string.isRequired,
  /**
   * Style class name for input group
   */
  inputGroupClassName: PropTypes.string,
  /**
   * A prefix for the input
   */
  inputClassName: PropTypes.string,
  /**
   * A prefix for the input
   */
  inputPrefix: PropTypes.string,
  /**
   * A suffix for the input
   */
  inputSuffix: PropTypes.string,
  /**
   * Label text
   */
  label: PropTypes.string,
  /**
   * Style class name for label
   */
  labelClassName: PropTypes.string,
  /**
   * Input required or not
   */
  required: PropTypes.bool,
  /**
   * Sub label text
   */
  subLabel: PropTypes.string,
  /**
   * Suffix text
   */
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Input validation
   */
  validation: PropTypes.object,
  /**
   * Check box
   */
  checked: PropTypes.bool,
  showErrors: PropTypes.bool,
};

export default CheckBox;
